// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageService } from '@med/app/core/language/service/language.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Language } from '@med/app/core/language/service/language.enum';
import { SpinnerService } from '@med/app/core/services/spinner.service';
import { DropdownComponent } from '../../../dropdown/dropdown/dropdown.component';
import { DropdownContentComponent } from '../../../dropdown/dropdown-content/dropdown-content.component';
import { NgClass } from '@angular/common';
import { DropdownItemComponent } from '../../../dropdown/dropdown-item/dropdown-item.component';

interface LanguageItem {
  code: string;
  value: string;
}

@Component({
  selector: 'e-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss'],
  imports: [
    DropdownComponent,
    DropdownContentComponent,
    DropdownItemComponent,
    NgClass,
  ],
})
export class LanguageSelectionComponent implements OnInit, OnDestroy {

  isDropdownActive = false;
  languages: LanguageItem[];
  selectedLanguage: string;
  showComponent: boolean;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private languageService: LanguageService,
    private spinnerService: SpinnerService,
  ) {

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    this.languages = [
      {code: Language.english, value: 'English'},
      {code: Language.chinese, value: '中文'},
      {code: Language.japanese, value: '日本語'},
    ];
    this.showComponent = this.languages.length > 1;

    this.languageService.getLanguage()
      .pipe(
        filter(value => !!value),
        takeUntil(this.unsubscribe$),
      ).subscribe(language => this.selectedLanguage = language);
  }

  public onCodeClick(code: string): void {
    if (code === this.selectedLanguage) {
      return;
    }
    this.spinnerService.show();
    this.languageService.saveLanguage(code);
    document.location.reload();
  }

  onToggleDropdown() {
    this.isDropdownActive = true;
  }
}
